var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 93h-6V69H54v24h-6V63h24v30ZM88.5 66C82.71 66 78 61.29 78 55.5S82.71 45 88.5 45 99 49.71 99 55.5 94.29 66 88.5 66Zm0-15a4.504 4.504 0 0 0-4.5 4.5c0 2.483 2.018 4.5 4.5 4.5 2.483 0 4.5-2.017 4.5-4.5S90.983 51 88.5 51Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 81C82.71 81 78 76.29 78 70.5S82.71 60 88.5 60 99 64.71 99 70.5 94.29 81 88.5 81Zm0-15a4.504 4.504 0 0 0-4.5 4.5c0 2.483 2.018 4.5 4.5 4.5 2.483 0 4.5-2.017 4.5-4.5S90.983 66 88.5 66Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 96C82.71 96 78 91.29 78 85.5S82.71 75 88.5 75 99 79.71 99 85.5 94.29 96 88.5 96Zm0-15a4.504 4.504 0 0 0-4.5 4.5c0 2.483 2.018 4.5 4.5 4.5 2.483 0 4.5-2.017 4.5-4.5S90.983 81 88.5 81ZM31.5 66C25.71 66 21 61.29 21 55.5S25.71 45 31.5 45 42 49.71 42 55.5 37.29 66 31.5 66Zm0-15a4.504 4.504 0 0 0-4.5 4.5c0 2.483 2.018 4.5 4.5 4.5 2.483 0 4.5-2.017 4.5-4.5S33.983 51 31.5 51Z",
    fill: "#222",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 81C25.71 81 21 76.29 21 70.5S25.71 60 31.5 60 42 64.71 42 70.5 37.29 81 31.5 81Zm0-15a4.504 4.504 0 0 0-4.5 4.5c0 2.483 2.018 4.5 4.5 4.5 2.483 0 4.5-2.017 4.5-4.5S33.983 66 31.5 66Z",
    fill: "#222",
    className: "fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 96C25.71 96 21 91.29 21 85.5S25.71 75 31.5 75 42 79.71 42 85.5 37.29 96 31.5 96Zm0-15a4.504 4.504 0 0 0-4.5 4.5c0 2.483 2.018 4.5 4.5 4.5 2.483 0 4.5-2.017 4.5-4.5S33.983 81 31.5 81ZM75 90H45v6h30v-6ZM57 39H42v6h15v-6ZM72 51H51v6h21v-6ZM12.518 46.085l-1.99-5.66 36.367-12.787 11.575-4.803 11.71-9.195 3.705 4.72-12.355 9.7-12.567 5.21-36.445 12.815Z",
    fill: "#222",
    className: "fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.483 46.085 70.96 33.242 58.47 28.06l-12.355-9.7 3.705-4.72 11.71 9.195 11.575 4.802 36.368 12.788-1.99 5.66Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHut);
export default __webpack_public_path__ + "static/media/hut.c23b7c9d.svg";
export { ForwardRef as ReactComponent };